import styled from "@emotion/styled";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Button as AIMEButton } from "tot-loft-component-library";
import * as PRTNR from "./prtnr";
import { updateFeaturedvendors } from "./redux/slices/FeaturedvendorsThunks";

export default function ModalAdminfeaturedvendoredit({ onClose, vendorValue }) {
  const dispatch = useDispatch();
  const [position, setPosition] = useState(vendorValue?.position);

  const handler = () => {
    const data = {
      _id: vendorValue._id,
      position: position,
    };
    dispatch(updateFeaturedvendors(data));
    onClose();
  };

  return (
    <RootWrapperModalAdminfeaturedvendorsone>
      <Wrapper>
        <Sector>
          <Left>
            <Frame58>
              <Frame1391>
                <SelectAVendor>Select a Vendor</SelectAVendor>
              </Frame1391>
              <Frame1391>
                <PRTNR.Select
                  label="Selected Vendor"
                  options={[]}
                  placeholder={vendorValue?.name}
                />
              </Frame1391>

              <Frame1418>
                <AIMEButton
                  size="small"
                  onClick={() => {
                    setPosition(0);
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    borderRadius: "999px",
                    background: "rgb(241, 245, 249)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "rgb(33, 37, 67)",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Clear
                  </span>
                </AIMEButton>

                <AIMEButton
                  size="small"
                  onClick={() => {
                    handler();
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    width: "240px",
                    background: "rgb(97, 98, 197)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Save
                  </span>
                </AIMEButton>
              </Frame1418>
            </Frame58>
          </Left>
        </Sector>
      </Wrapper>
    </RootWrapperModalAdminfeaturedvendorsone>
  );
}

const RootWrapperModalAdminfeaturedvendorsone = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  border-radius: 32px;
  width: 534px;
  padding: 24px;
`;

const Sector = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  box-sizing: border-box;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const SelectAVendor = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1418 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
